var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2444_86045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 66.133558,16.976692 h -0.707772 c 0,0 -8.67342,2.950827 -9.21402,17.096154 -0.145255,4.555188 -0.698461,10.038738 0.806656,11.6814 1.504229,1.642661 3.972213,1.551209 3.79991,2.920366 -0.171416,1.368241 -2.384366,23.270434 -2.119135,24.366086 0.266056,1.094802 0.531289,3.196418 3.540633,3.057936 3.008586,-0.137569 3.716358,-1.689629 3.893728,-3.514343 0.132585,-1.363931 0.0667,-31.728372 0.02534,-46.998975",
    stroke: "url(#gradient-333)",
    strokeWidth: 2.57307,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path2-0",
    style: {
      stroke: "url(#linearGradient2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.185227,41.871093 c -1.043065,0.26743 -1.701047,0.958083 -1.643592,1.706219 0.433292,5.645616 2.12167,27.698442 2.12167,28.812384 0,2.002391 -0.679076,3.145924 -4.68005,3.110258 -3.843873,-0.03397 -5.188532,-0.938028 -5.188532,-3.23829 0,-2.005789 1.833694,-23.177219 2.30417,-28.57461 0.06335,-0.727233 -0.552382,-1.404822 -1.550726,-1.693155 -1.167288,-0.337913 -3.211268,-0.859642 -4.20201,-1.257651 -1.723877,-0.692418 -3.565148,-1.232437 -3.375108,-4.299975 0.190882,-3.067538 1.124187,-18.185729 1.124187,-18.185729 0,0 0.444276,-0.895347 1.777931,-0.767316 1.333656,0.128032 1.714584,0.767316 1.714584,0.767316 l -0.06335,15.416976 c 0,0 0.963731,0.786481 2.297368,0.786481 1.333636,0 2.484898,-0.4033 2.484898,-0.743825 0,-0.341441 0.776186,-15.24885 0.776186,-15.24885 0,0 0.126693,-0.864006 1.904643,-0.864006 1.778774,0 1.715427,0.864006 1.715427,0.864006 l 0.06842,15.206194 c 0,0 1.298986,0.882244 2.632686,0.882244 1.333636,0 2.086194,-0.96762 2.086194,-0.96762 l 0.461984,-15.461363 c 0,0 0.380966,-0.834388 1.841296,-0.694168 1.461217,0.140228 1.58791,0.573968 1.58791,0.573968 0,0 0.852202,16.569236 0.534646,18.912153",
    stroke: "url(#gradient-333)",
    strokeWidth: 2.57307,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path1-8",
    style: {
      stroke: "url(#linearGradient1)"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 82,
    height: 82,
    rx: 41,
    stroke: "url(#gradient-333)",
    strokeWidth: 6,
    shapeRendering: "geometricPrecision",
    id: "rect5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2444_86045",
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    id: "feFlood5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha",
    id: "feColorMatrix5"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    id: "feOffset5"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    id: "feGaussianBlur5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    id: "feComposite5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.670588 0 0 0 0 0.745098 0 0 0 0 0.819608 0 0 0 0.6 0",
    id: "feColorMatrix6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2444_86045",
    id: "feBlend6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2444_86045",
    result: "shape",
    id: "feBlend7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y1: 46,
    id: "gradient-333",
    x1: 4,
    y2: 46,
    x2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient-333",
    id: "linearGradient1",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 46,
    x2: 92,
    y2: 46,
    gradientTransform: "matrix(0.63346629,0,0,0.65322349,25.284735,15.303447)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient-333",
    id: "linearGradient2",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 46,
    x2: 92,
    y2: 46,
    gradientTransform: "matrix(0.63346629,0,0,0.65322349,25.284735,15.303447)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipes);
export default __webpack_public_path__ + "static/media/recipes.0d78734573539b37bfa812e1b9798492.svg";
export { ForwardRef as ReactComponent };